import { render } from "./VAImport.vue?vue&type=template&id=54bb4b3b&ts=true"
import script from "./scripts/va-import.ts?vue&type=script&lang=ts"
export * from "./scripts/va-import.ts?vue&type=script&lang=ts"

import "./VAImport.vue?vue&type=style&index=0&id=54bb4b3b&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__